// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__ozNrH","load2":"Spinner_load2__3QEoO"};